function calculateTotalSavings(unitListPrice, unitDiscountedPrice, unitListPriceForMoq, currency, isVatInclusive) {
  const unitPriceMoq = isVatInclusive ? unitListPriceForMoq.taxed : unitListPriceForMoq.untaxed;
  const { unitDiscountedPrice: discountedPrice } = getUnitPriceDetails(
    unitListPrice,
    unitDiscountedPrice,
    isVatInclusive,
    currency
  );
  const savings = getPercentage(discountedPrice, unitPriceMoq);
  return savings;
}
function isDiscounted(totalListPrice, totalDiscountedPrice, isVatInclusive) {
  const listPrice = isVatInclusive ? totalListPrice.taxed : totalListPrice.untaxed;
  const discountedPrice = isVatInclusive ? totalDiscountedPrice.taxed : totalDiscountedPrice.untaxed;
  return listPrice !== discountedPrice;
}
function getPercentage(value, referenceValue) {
  return Math.round((1 - value / referenceValue) * 100);
}
function getUnitPriceDetails(unitListPrice, unitDiscountedPrice, isVatInclusive, currency) {
  if (!unitListPrice || !unitDiscountedPrice || !currency) {
    throw new Error("One or more required parameters are null or undefined: unitListPrice, unitDiscountedPrice, or currency.");
  }
  return {
    unitPrice: isVatInclusive ? unitListPrice.taxed : unitListPrice.untaxed,
    unitDiscountedPrice: isVatInclusive ? unitDiscountedPrice.taxed : unitDiscountedPrice.untaxed,
    currency
  };
}

export { calculateTotalSavings, isDiscounted };
//# sourceMappingURL=src-util-price-calculator-helper.js.map
